// extracted by mini-css-extract-plugin
export default {"flexColumn":"flex-column_flexColumn__ZzEwy"};